import React, { useEffect, useState, useRef } from 'react';
import SignatureCanvas from 'react-signature-canvas';
import Button from '../../components/button';
import Header from '../../components/header';
import styles from './sign-page.module.scss';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import { uploadDocumentSignature } from '../../api/documentApi';
import Spinner from '../../components/spinner';
import dataURItoBlob from '../../helpers/dataURItoBlob';

const SignPage = () => {
  const sigCanvas = useRef(null);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { documentId } = useParams();
  const [spinner, setSpinner] = useState(false);
  const [errorMessage, setErrorMessage] = useState();
  const [valid, setValid] = useState(false);
  const [touched, setTouched] = useState(false);

  const uploadSign = () => {
    setTouched(true);
    if (!valid) return;
    setSpinner(true);

    const signature = dataURItoBlob(sigCanvas.current.toDataURL('image/png'));

    uploadDocumentSignature(documentId, signature)
      .then(() => {
        setSpinner(false);
        navigate(`/success/${documentId}`);
      })
      .catch(({ message }) => {
        setSpinner(false);
        setErrorMessage(message || 'Failed to sign document');
        navigate('/failed');
      });
  };

  useEffect(() => {
    if (!documentId) {
      navigate('/failed');
    }
  }, [documentId, navigate]);

  return (
    <div className={styles.signPage}>
      {spinner && <Spinner fullPage={true} />}
      <Header />

      <div className="container">
        <div className="sign">
          <label>{t('sign_here')}</label>

          <div className={`${styles.draw} ${!valid && touched && styles.error}`}>
            <SignatureCanvas
              ref={sigCanvas}
              onEnd={() => {
                setTouched(true);
                setValid(!sigCanvas.current.isEmpty());
              }}
              canvasProps={{ width: 288, height: 150 }}
              minWidth={3}
              maxWidth={3}
              velocityFilterWeight={1}
            />
          </div>
        </div>

        {errorMessage && <div className={styles.error}>{errorMessage}</div>}

        <div className={styles.buttons}>
          <div>
            <Button disabled={!valid && touched} className="full-width" onClick={uploadSign}>
              {t('save')}
            </Button>
          </div>
          <div>
            <Button
              className="full-width cancel"
              onClick={() => {
                sigCanvas.current.clear();
                setValid(false);
              }}
            >
              <span className="material-symbols-outlined">close</span> {t('clear')}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignPage;
